import {
  DROPDOWN_OPTIONS_ROLE,
  MOBUI_PICKER_OPTIONS_ROLE,
  USER_INPUT_FILTER_V1_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
} from '@wix/wix-data-client-common-standalone'

import { Breadcrumb, Logger } from '../logger'
import { isEditable } from '../dataset-controller/rootReducer'
import { AdaptedComponent } from '../inverted-dependencies/components/componentFactory'
import { USER_INPUT_FILTER_ROLES } from '../helpers/constants'

import { getUniqueDisableableComponents } from './utils'
import { StateSideEffectSubscriberFactory } from './types'


export const syncInputComponentsWithStateFactory: StateSideEffectSubscriberFactory = ({
  store: { getState },
  logger,
  datasetId,
  components,
}) => {
  const inputComponents = getDisableableInputComponents(components)

  if (inputComponents.length === 0) {
    return
  }

  return () => {
    const shouldBeEnabled = isEditable(getState())

    inputComponents.forEach(component => {
      updateInputComponentEnabledState(
        component,
        shouldBeEnabled,
        logger,
        datasetId,
      )
    })
  }
}

const undisableableRoles = [
  DROPDOWN_OPTIONS_ROLE,
  MOBUI_PICKER_OPTIONS_ROLE,
  USER_INPUT_FILTER_V1_ROLE,
  SELECTION_TAGS_OPTIONS_ROLE,
  ...USER_INPUT_FILTER_ROLES,
]

const getDisableableInputComponents = (components: AdaptedComponent[]) =>
  getUniqueDisableableComponents(components).filter(
    ({ role, isInput }) => isInput && !undisableableRoles.includes(role),
  )

const updateInputComponentEnabledState = (
  component: AdaptedComponent,
  shouldBeEnabled: boolean,
  logger: Logger,
  datasetId: string,
) => {
  if (component.enabled == shouldBeEnabled) {
    return
  }

  if (shouldBeEnabled) {
    component.enable()
  } else {
    component.disable()
  }

  logger.log(
    new Breadcrumb({
      category: 'components',
      message: `${component.id} changed to ${shouldBeEnabled ? 'enabled' : 'disabled'} (dataset: ${datasetId})`,
    }),
  )
}
